import { PathMenuItem } from "core/FeaturePathMenus";

export const pathMenus: PathMenuItem[] = [
  {
    url_id: "/laporan/bsya-junior",
    url_path: "/laporan/bsya-junior",
  },
];
